import { render, staticRenderFns } from "./VerifyCorporateUsername.vue?vue&type=template&id=64a17a54&scoped=true"
import script from "./VerifyCorporateUsername.vue?vue&type=script&lang=js"
export * from "./VerifyCorporateUsername.vue?vue&type=script&lang=js"
import style0 from "./VerifyCorporateUsername.vue?vue&type=style&index=0&id=64a17a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a17a54",
  null
  
)

export default component.exports